import React from 'react';
import Select from 'react-select';
import { jdsSelectProps } from '../../../components/jds/selectProps';
import { useItemSelectBootstrap } from '../create/create-offer.bootstrap.hook';

// `selectedIds`: itens já escolhidos em outras linhas (ficam desabilitados).
export function ItemSelect({ value, onChange, selectedIds = [] }) {
  const { items, loading, setSearchText } = useItemSelectBootstrap();

  return (
    <Select
      isSearchable
      isClearable
      isLoading={loading}
      isOptionDisabled={(option) => selectedIds.includes(option.id)}
      options={items}
      placeholder="Buscar por nome"
      noOptionsMessage={() => 'Nenhum resultado encontrado'}
      loadingMessage={() => 'Buscando itens...'}
      // A busca é feita no servidor; evita filtrar de novo no cliente.
      filterOption={null}
      onInputChange={(text, { action }) => {
        if (action === 'input-change') setSearchText(text);
      }}
      getOptionLabel={(option) => option.name}
      getOptionValue={(option) => option.id}
      value={value}
      onChange={(option) => onChange(option || null)}
      {...jdsSelectProps}
    />
  );
}
